import { render, staticRenderFns } from "./DistributorRatingCard.vue?vue&type=template&id=6aaa40f6&scoped=true"
import script from "./DistributorRatingCard.vue?vue&type=script&lang=js"
export * from "./DistributorRatingCard.vue?vue&type=script&lang=js"
import style0 from "./DistributorRatingCard.vue?vue&type=style&index=0&id=6aaa40f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaa40f6",
  null
  
)

export default component.exports